import { useLocalObservable } from 'mobx-react';
import { useContext } from 'react';
import { AppService } from '@ibe/services';
import { AppContext } from './Contexts';

function useAppService(): AppService {
  const context = useContext(AppContext);
  return useLocalObservable<AppService>(() => context);
}

export default useAppService;
